import CascaderPanel from './src/index.mjs';
export { CASCADER_PANEL_INJECTION_KEY, ExpandTrigger } from './src/types.mjs';
export { CommonProps, DefaultProps, useCascaderConfig } from './src/config.mjs';

CascaderPanel.install = (app) => {
  app.component(CascaderPanel.name, CascaderPanel);
};
const _CascaderPanel = CascaderPanel;
const ElCascaderPanel = _CascaderPanel;

export { ElCascaderPanel, _CascaderPanel as default };
//# sourceMappingURL=index.mjs.map
